import { render, staticRenderFns } from "./icon-show.vue?vue&type=template&id=18466535"
import script from "./icon-show.vue?vue&type=script&lang=ts"
export * from "./icon-show.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports